<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <div class="p-5">
        <v-card :loading="loading" class="p-5" flat>
          <v-row class="pb-0 pt-4">
            <v-col
              cols="12"
              md="4"
              style="height: fit-content; position: sticky; top: 16px"
            >
              <div class="text-center pb-4">
                 
                <v-tabs v-model="tabs" class="mb-4" grow>
                  <v-tab>سریع</v-tab>
                  <v-tab>پیشرفته</v-tab>
                </v-tabs>

                <v-btn-toggle v-model="toggle_exclusive">
                  <v-btn :value="6">
                    <v-icon>mdi-view-grid</v-icon>
                  </v-btn>

                  <v-btn :value="4">
                    <v-icon>mdi-view-module</v-icon>
                  </v-btn>

                  <v-btn :value="3">
                    <v-icon>mdi-view-comfy</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </div>

              <div v-if="loading" class="text-center pa-4">
                <v-progress-circular
                  color="success"
                  indeterminate
                  size="50"
                  width="5"
                />
              </div>

              <v-tabs-items v-model="tabs">
                <v-tab-item>
                  <v-row no-gutters>
                    <v-col
                      v-for="index in Number(count)"
                      :key="index"
                      :cols="toggle_exclusive"
                      class="pa-2"
                      @click="downloadImg(qrSvgDataUrl[index - 1], index)"
                    >
                      <img
                        :src="qrSvgDataUrl[index - 1]"
                        alt=""
                        class="cursor-pointer"
                        width="100%"
                      />
                      <v-card-subtitle
                        class="pa-0 text-center"
                        v-text="index"
                      />
                    </v-col>
                  </v-row>
                </v-tab-item>

                <v-tab-item>
                  <v-card 
                  class="mt-4 rounded-xl" 
                  color="grey lighten-5" 
                  elevation="0" 
                  style="border: 1px solid #F3C4C4;"
                  v-if="qrSvgDataUrl?.length>0 && count>0"
                >
                  <v-card-text class="pa-4">
                    <div class="text-center font-weight-bold mb-3 text-subtitle-1 grey--text text--darken-2">
                      انتخاب فرمت و دانلود
                    </div>
                    
                    <v-row align="center" justify="center" no-gutters>
                      <!-- بخش انتخاب فرمت به صورت Toggle -->
                      <v-col cols="12" class="d-flex justify-center mb-4" v-if="1">
                        <v-btn-toggle
                          v-model="typeDownload"
                          mandatory
                          rounded
                          active-class="primary white--text elevation-1"
                          class="background-white elevation-9" 
                        >
                          <v-btn value="svg" class="px-1 pr-1 font-weight-bold">
                              <v-icon left size="10" class="ml-1" :color="typeDownload === 'svg' ? 'white' : ''">
                                mdi-vector-curve</v-icon>
                            <span small>SVG</span>
                          </v-btn>
                          <v-btn value="png" class="px-1 font-weight-bold" >
                            <v-icon left size="10" class="ml-1" :color="typeDownload === 'png' ? 'white' : ''">mdi-image-outline</v-icon>
                           <span small>PNG</span>
                          </v-btn>
                          <v-btn value="jpg" class="px-1 font-weight-bold" >
                            <v-icon left size="10" class="ml-1" :color="typeDownload === 'jpg' ? 'white' : ''">mdi-image</v-icon>
                            <span small>JPG</span>
                          </v-btn>
                          <v-btn value="webp" class="pl-1 pr-1 font-weight-bold">
                            <v-icon left size="10" class="ml-1" :color="typeDownload === 'webp' ? 'white' : ''">mdi-image-outline</v-icon>
                            <span x-small>WEBP</span>
                          </v-btn>
                          <v-btn value="dxf" class="pl-1 pr-1 font-weight-bold">
                            <v-icon left size="10" class="ml-1" :color="typeDownload === 'dxf' ? 'white' : ''">mdi-vector-polyline</v-icon>
                            <span x-small>DXF</span>
                          </v-btn>

                        </v-btn-toggle>
                      </v-col>

                      <!-- دکمه دانلود -->
                                               <v-col>
                        <v-alert cols="12" md="12" class="d-flex justify-center mb-4" v-if="isDownloading" colored-border type="info" outlined >تا پایان فرایند دانلود پنجره را نبندید</v-alert>
                        </v-col>

                      <v-col cols="12" class="d-flex justify-center">
                        <v-btn
                          :loading="isDownloading" 
                          class="rounded-lg btn-download"
                          elevation="3"
                          height="48"
                          @click="downloadQr"
                        >
                          <v-icon right size="24" class="ml-2">mdi-cloud-download-outline</v-icon>
                          <span class="font-weight-bold text-body-1">دانلود گروهی</span>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
                  <v-switch
                    v-model="selectFromGroup"
                    label="طرح پیش فرض"
                  />
                                    <v-switch
                    v-model="random2"
                    label="طرح تصادفی"
                  />


                  <v-row v-if="tabs === 1" no-gutters>
                    
                    <v-col
                      v-for="index in Number(count)"
                      :key="`${index}-advance`"
                      :cols="toggle_exclusive"
                      class="pa-2"
                      @click="
                        downloadSvgImg(
                          `${
                            qrSvgDataUrl[index - 1]
                          }`,
                          index,
                        )
                      "
                    >
                    <div v-if="qrSvgDataUrl[index - 1]?.includes('<svg') "
                        v-html="qrSvgDataUrl[index - 1]"
                        class="cursor-pointer d-flex qr-wrapper"
                        style="width: 100%; justify-content: center; align-items: start;" 
                    ></div>                      
                    <img v-if="!!qrSvgDataUrl[index - 1] && !qrSvgDataUrl[index - 1]?.includes('<svg')"
                      :src="qrSvgDataUrl[index - 1]?.includes('data:image') ? qrSvgDataUrl[index - 1] : 'data:image/svg+xml;base64,' + qrSvgDataUrl[index - 1]"
                      alt="QR Code"
                      class="cursor-pointer"
                      width="100%"
                    />
                    <img v-if="!qrSvgDataUrl[index - 1]"
                      src="/media/qr-code.gif"
                      alt="QR Code"
                      class="cursor-pointer"
                      width="100%"
                    />

                      <v-card-subtitle
                        class="pa-0 text-center"
                        v-text="index"
                      />
                    </v-col>
                  </v-row>
               

                </v-tab-item>
              </v-tabs-items>
            </v-col>

            <v-col
              cols="12"
              md="8"
              style="height: fit-content; position: sticky; top: 0"
            >
              <v-card-title class="pt-0">
                تعداد کیوآرکد مورد نظر خودرا وارد نمایید:
              </v-card-title>

            <v-card-subtitle>
              <div class="d-flex flex-row justify-contant-center">
                <v-text-field
                  v-model="count"
                  class="rounded-lg my-0"
                  dense
                  label="تعداد"
                  outlined
                  type="number"
                  max="1000"
                  :rules="[rules.count]"
                >
                </v-text-field>
                <v-btn
                      :loading="loading"
                      class="btn-get-code rounded-lg my-0"
                      @click.stop="updateStyle(false)"
                      :disabled="!isFormChanged" 
                    ><v-icon small>mdi-qrcode</v-icon>
                      ساخت تصاویر
                    </v-btn>

              </div>              
              </v-card-subtitle>

          <v-expansion-panels class="px-4" flat mandatory>
            <v-expansion-panel class="mb-4">
              <v-expansion-panel-header class="text-right">
                <div class="d-flex align-center">
                  <v-icon class="me-2">mdi-qrcode-edit</v-icon>
                  نوع کیوآرکد و اطلاعات
                </div>
              </v-expansion-panel-header>

              <v-expansion-panel-content class="py-5">
                 <div class="mb-4" v-if="$vuetify.breakpoint.smAndDown">
    <label class="text-subtitle-1 font-weight-bold mb-2 d-block grey--text text--darken-2">
      نوع کیوآرکد
    </label>
    
    <v-slide-group 
      v-model="selectedQrType"
      class="py-2"
      active-class="primary white--text"
      mandatory
      show-arrows
    >
      <v-slide-item
        v-for="type in qrTypesList"
        :key="type.value"
        v-slot="{ active, toggle }"
        :value="type.value"
      >
        <v-chip
          class="mx-2 px-5 py-5 rounded-lg"
          :color="active ? 'primary' : 'grey lighten-4'"
          :text-color="active ? 'white' : 'grey darken-3'"
          large
          @click="toggle"
          style="cursor: pointer; transition: all 0.3s ease;"
        >
          <v-icon left size="22" :class="active ? 'white--text' : 'primary--text'">
            {{ type.icon }}
          </v-icon>
          <span class="font-weight-medium text-body-1">{{ type.title }}</span>
        </v-chip>
      </v-slide-item>
    </v-slide-group>
                </div>
                <div class="mb-6" v-else>
  <label class="text-subtitle-1 font-weight-bold mb-3 d-block grey--text text--darken-2">
    نوع کیوآرکد را انتخاب کنید
  </label>
  
  <v-item-group v-model="selectedQrType" mandatory>
    <v-row dense> 
      <v-col
        v-for="type in qrTypesList"
        :key="type.value"
        cols="4"       
        sm="3"        
        md="2"      
        class="pa-1" 
      >
        <v-item v-slot="{ active, toggle }" :value="type.value">
          <v-card
            :color="active ? '#0a194e' : 'white'" 
            :class="active ? 'elevation-7' : 'elevation-4'"
            class="qr-type-card d-flex flex-column align-center justify-center pa-2 rounded-lg transition-swing"
            height="100"
            @click="toggle"
          >
            <v-icon 
              :color="active ? 'white' : 'grey darken-2'" 
              size="30" 
              class="mb-2"
            >
              {{ type.icon }}
            </v-icon>
            
            <span 
              :class="active ? 'white--text' : 'grey--text text--darken-3'"
              class="text-caption font-weight-bold text-center"
              style="line-height: 1.2;"
            >
              {{ type.title }}
            </span>
          </v-card>
        </v-item>
      </v-col>
    </v-row>
  </v-item-group>
</div>

                <!-- Text & URL -->
                <v-row v-if="selectedQrType === 'url' || selectedQrType === 'text'">
                  <v-col cols="12">
                    <v-text-field 
                      v-if="selectedQrType === 'url'" 
                      v-model="qrData.param" 
                      label="لینک" 
                      :rules="[rules.url]"
                      outlined dense dir="ltr" 
                      placeholder="آدرس اینترنتی خود را وارد کنید">
                    </v-text-field>
                    <suggest-text v-if="selectedQrType === 'text'" v-model="qrData.param" label="متن" rows="6" placeholder="متن خود را وارد کنید"/>
                  </v-col>
                </v-row>

                <!-- Email -->
                <v-row v-if="selectedQrType === 'email'">
                  <v-col cols="12" md="6">
                    <v-text-field v-model="qrData.email.mailto" :rules="[rules.email]" label="آدرس ایمیل" outlined dense dir="ltr"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="qrData.email.subject" label="موضوع" outlined dense></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <suggest-text v-model="qrData.email.body" label="متن پیام" rows="6" />
                  </v-col>
                </v-row>

                <!-- Telephone -->
                <v-row v-if="selectedQrType === 'tel'">
                  <v-col cols="12" style="direction: ltr !important">
                    <div class="stylephone">
                      <label class="mb-2 d-block text-right">شماره تلفن</label>
                      <vue-tel-input
                        v-model="qrData.tel.tel"
                        default-country="IR"
                        :preferred-countries="['IR', 'IQ', 'US', 'CA', 'GB', 'AE']"
                          :inputOptions="{ placeholder: 'شماره تلفن را وارد کنید...' }"
                        class="rounded-lg phone-input w-100 py-1"
                        @validate="(data) => handlePhoneValidation(data, 'tel', 'countrycodetel', 'tel')"
                      />
                    </div>
                  </v-col>
                </v-row>
                <!-- SMS -->
                <v-row v-if="selectedQrType === 'sms'">
                  <v-col cols="12" style="direction: ltr !important">
                    <div class="stylephone">
                      <label class="mb-2 d-block text-right">شماره موبایل</label>
                      <vue-tel-input
                        v-model="qrData.sms.sms"
                        default-country="IR"
                        :preferred-countries="['IR', 'IQ', 'US', 'CA', 'GB', 'AE']"
                        :inputOptions="{ placeholder: 'شماره موبایل را وارد کنید...' }"

                        class="rounded-lg phone-input w-100 py-1"
                        @validate="(data) => handlePhoneValidation(data, 'sms', 'countrycodesms', 'sms')"
                      />
                    </div>
                  </v-col>
                  <v-col cols="12">
                      <suggest-text v-model="qrData.sms.bodysms" label="متن پیامک" rows="6" />
                  </v-col>
                </v-row>

                <!-- WhatsApp -->
                  <v-row v-if="selectedQrType === 'whatsapp'">
                    <v-col cols="12" style="direction: ltr !important">
                      <div class="stylephone">
                        <label class="mb-2 d-block text-right">شماره واتس‌اپ</label>
                        <vue-tel-input
                          v-model="qrData.whatsapp.wapp_number"
                          default-country="IR"
                          :preferred-countries="['IR', 'IQ', 'US', 'CA', 'GB', 'AE']"
                          :inputOptions="{ placeholder: 'شماره واتس‌اپ را وارد کنید...' }"
                          class="rounded-lg phone-input w-100 py-1"
                          @validate="(data) => handlePhoneValidation(data, 'whatsapp', 'wapp_countrycode', 'wapp_number')"
                        />
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <suggest-text v-model="qrData.whatsapp.wapp_message" label="متن پیام" rows="6" />
                    </v-col>
                  </v-row>

                <!-- Zoom -->
                <v-row v-if="selectedQrType === 'zoom'">
                  <v-col cols="12" md="6">
                    <v-text-field v-model="qrData.zoom.zoom_id" label="آیدی زوم" outlined dense dir="ltr"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="qrData.zoom.zoom_pwd" label="رمز عبور" outlined dense dir="ltr"  :type="showPassword ? 'text' : 'password'"
    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
    @click:append="showPassword = !showPassword"></v-text-field>
                  </v-col>
                </v-row>

                <!-- WiFi -->
                <v-row v-if="selectedQrType === 'wifi'">
                  <v-col cols="12" md="6">
                    <v-text-field v-model="qrData.wifi.ssid" label="نام شبکه" outlined dense dir="ltr"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="qrData.wifi.wifipass" label="رمز عبور" outlined dense dir="ltr" :type="showPassword ? 'text' : 'password'"
    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
    @click:append="showPassword = !showPassword"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-select v-model="qrData.wifi.networktype" :items="['WPA2', 'WEP', 'nopass']" label="نوع رمزنگاری" outlined dense></v-select>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-switch v-model="qrData.wifi.wifihidden" label="شبکه مخفی است؟"></v-switch>
                  </v-col>
                </v-row>

                <!-- Location -->
                <v-row v-if="selectedQrType === 'location'">
                  <v-col cols="12" md="6">
                    <v-text-field v-model="qrData.location.lat" label="عرض جغرافیایی" outlined dense dir="ltr"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="qrData.location.lng" label="طول جغرافیایی" outlined dense dir="ltr"></v-text-field>
                  </v-col>
                  <v-col>
                      <v-autocomplete
                      outlined
                      dense
                    v-model="searchTitle"
                    :items="suggests"
                    :search-input.sync="searchQuery"
                    :loading="mapLoading"
                    item-text="title"
                    item-value="geom"
                    label="جستجوی آدرس..."
                    prepend-icon="mdi-map-search"
                    hide-no-data
                    hide-details
                    clearable
                    return-object
                    @change="getBySearch"
                    class="mb-4"
                  ></v-autocomplete>
                  </v-col>
                  <mapir
                    :apiKey="apiKey"
                    :center="[qrData.location.lng || 51.420296, qrData.location.lat || 35.732379]"
                    :zoom="zoomMap || 15"
                    class="col-md-12"
                    style="width: 100%; height: 500px; border-radius: 8px;"
                    @click="getlatLng"
                  >
                    <!-- ابزارهای نقشه -->
                    <mapNavigationControl :showUserLocation="true" position="top-right"/>
                    <mapGeolocateControl position="top-right" show-user-location track-user-location/>

                    <!-- مارکر که مختصاتش دقیقاً به qrData وصل است -->
                    <mapMarker 
                      :coordinates="[qrData.location.lng || 51.420296, qrData.location.lat || 35.732379]" 
                      color="red"
                    >
                      <template v-slot:marker>
                        <v-icon color="error" large>mdi-map-marker</v-icon>
                      </template>
                    </mapMarker>
                  </mapir>
                  <!-- <v-col cols="12">
                    <v-text-field 
                      v-model="mapSearchQuery" 
                      label="جستجوی آدرس روی نقشه" 
                      outlined dense
                      append-icon="mdi-magnify"
                      @click:append="searchMapLocation"
                      @keyup.enter="searchMapLocation"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <div id="map" style="width: 100%; height: 350px; border-radius: 8px; border: 1px solid #ccc; z-index: 1;"></div>
                  </v-col> -->
                </v-row>

                <!-- Bitcoin -->
                <v-row v-if="selectedQrType === 'bitcoin'">
                  <v-col cols="12">
                    <v-text-field v-model="qrData.bitcoin.btc_account" :rules="[rules.bitcoinAddress]" label="آدرس کیف پول" outlined dense dir="ltr"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-text-field v-model="qrData.bitcoin.btc_amount" :rules="[rules.positiveNumber]" label="مقدار" type="number" outlined dense dir="ltr"></v-text-field>
                  </v-col>
                  <v-col cols="12" md="8">
                    <v-text-field v-model="qrData.bitcoin.btc_label" label="برچسب" outlined dense></v-text-field>
                  </v-col>
                  <v-col cols="12">
                      <suggest-text v-model="qrData.bitcoin.btc_message" label="پیام" rows="6" />
                  </v-col>
                </v-row>

               <!-- PayPal -->
              <v-row v-if="selectedQrType === 'paypal'">
                <v-col cols="12" md="6">
                  <v-select v-model="qrData.paypal.pp_type" :items="[{value:'_xclick', text:'خرید اکنون'}, {value:'_cart', text:'افزودن به سبد خرید'},{ value:'_donations',text:'کمک مالی'}]" label="نوع پرداخت" outlined dense></v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="qrData.paypal.pp_email" :rules="[rules.email]" label="ایمیل پی‌پال" outlined dense dir="ltr"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="qrData.paypal.pp_name" label="نام آیتم" outlined dense></v-text-field>
                </v-col>
                
                <v-col cols="12" md="6">
                  <v-autocomplete 
                    v-model="qrData.paypal.pp_currency" 
                    :items="paypalCurrencies" 
                    item-text="text" 
                    item-value="value" 
                    label="واحد پول" 
                    outlined 
                    dense 
                    dir="ltr">
                  </v-autocomplete>
                </v-col>

                <v-col cols="12" md="6">
                  <v-text-field 
                    v-model="qrData.paypal.pp_price" 
                    label="قیمت" 
                    type="number" 
                    outlined 
                    dense 
                    dir="ltr"
                    :suffix="qrData.paypal.pp_currency"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field 
                    v-model="qrData.paypal.pp_shipping" 
                    label="حمل و نقل" 
                    type="number" 
                    outlined 
                    dense 
                    dir="ltr"
                    :suffix="qrData.paypal.pp_currency"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field 
                    v-model="qrData.paypal.pp_tax" 
                    label="نرخ مالیات" 
                    type="number" 
                    outlined 
                    dense 
                    dir="ltr"
                    suffix="%"
                  ></v-text-field>
                </v-col>
              </v-row>

                <!-- Event -->
                <v-row v-if="selectedQrType === 'event'">
                  <v-col cols="12" md="6">
                    <v-text-field v-model="qrData.event.eventtitle" label="عنوان رویداد" outlined dense></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                    <v-text-field v-model="qrData.event.eventlocation" label="مکان رویداد" outlined dense></v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                  <date-picker
                      v-model="qrData.event.eventstarttime"
                      type="datetime"
                      format="YYYY-MM-DD HH:mm"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      :timezone="false"
                      auto-submit
                      label="زمان شروع"
                      endTime
                    ></date-picker>
                  </v-col>
                  <v-col cols="12" md="6">
                  <date-picker
                      v-model="qrData.event.eventendtime"
                      type="datetime"
                      format="YYYY-MM-DD HH:mm"
                      display-format="jYYYY-jMM-jDD HH:mm"
                      :timezone="false"
                      auto-submit
                      label="زمان پایان"
                      endTime
                    ></date-picker>
                  </v-col>
                    <v-col cols="12" md="12">
                    <v-select
                      v-model="qrData.event.eventreminder"
                      :items="eventReminderOptions"
                      label="زمان یادآوری رویداد"
                      outlined
                      dense
                    ></v-select>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field v-model="qrData.event.eventlink" :rules="[rules.url]" label="لینک رویداد" outlined dense dir="ltr"></v-text-field>
                  </v-col>
                  <v-col cols="12">
                      <suggest-text v-model="qrData.event.eventnote" label="یادداشت رویداد" rows="6" />
                  </v-col>
                </v-row>

                <!-- vCard -->
              <v-row v-if="selectedQrType === 'vcard'">
                  <v-col cols="12">
                      <v-select
                        v-model="qrData.vcard.vversion"
                        :items="['2.1', '3.0']"
                        label="نسخه"
                        outlined
                        dense
                      ></v-select>
                  </v-col>
                  <v-col cols="12" md="3"><v-text-field v-model="qrData.vcard.vnametitle" label="عنوان/لقب" outlined dense></v-text-field></v-col>
                  <v-col cols="12" md="4"><v-text-field v-model="qrData.vcard.vname" label="نام" outlined dense></v-text-field></v-col>
                  <v-col cols="12" md="5"><v-text-field v-model="qrData.vcard.vlast" label="نام خانوادگی" outlined dense></v-text-field></v-col>

                  <v-col cols="12" md="6" style="direction: ltr !important">
                    <div class="stylephone">
                      <label class="mb-2 d-block text-right">شماره موبایل</label>
                      <vue-tel-input
                        v-model="qrData.vcard.vmobile"
                        default-country="IR"
                        :preferred-countries="['IR', 'IQ', 'US', 'CA', 'GB', 'AE']"
                        class="rounded-lg phone-input w-100 py-1"
                        :inputOptions="{ placeholder: 'شماره موبایل را وارد کنید...' }"
                        @validate="(data) => handlePhoneValidation(data, 'vcard', 'countrycodevmobile', 'vmobile')"
                      />
                    </div>
                  </v-col>

                  <v-col cols="12" md="6" style="direction: ltr !important">
                    <div class="stylephone">
                      <label class="mb-2 d-block text-right">تلفن محل کار</label>
                      <vue-tel-input
                        v-model="qrData.vcard.vofficephone"
                        default-country="IR"
                        :preferred-countries="['IR', 'IQ', 'US', 'CA', 'GB', 'AE']"
                        class="rounded-lg phone-input w-100 py-1"
                        :inputOptions="{ placeholder: 'شماره محل کار را وارد کنید...' }"
                        @validate="(data) => handlePhoneValidation(data, 'vcard', 'countrycodevoffice', 'vofficephone')"
                      />
                    </div>
                  </v-col>

                  <v-col cols="12" md="6"><v-text-field v-model="qrData.vcard.vemail" :rules="[rules.email]" label="ایمیل" outlined dense dir="ltr"></v-text-field></v-col>
                  <v-col cols="12" md="6"><v-text-field v-model="qrData.vcard.vurl" :rules="[rules.url]" label="وب‌سایت" outlined dense dir="ltr"></v-text-field></v-col>

                  <v-col cols="12" md="6"><v-text-field v-model="qrData.vcard.vcompany" label="نام شرکت" outlined dense></v-text-field></v-col>
                  <v-col cols="12" md="6"><v-text-field v-model="qrData.vcard.vtitle" label="سمت شغلی" outlined dense></v-text-field></v-col>

                  <v-col cols="12" md="12"><suggest-text v-model="qrData.vcard.vaddress" label="آدرس" rows="6" /></v-col>
                  <v-col cols="12" md="6">
                    <v-text-field 
                      v-model="qrData.vcard.vcap" 
                      type="number" 
                      :rules="[rules.postalCode]"
                      label="کد پستی" 
                      outlined dense dir="ltr">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6"><v-text-field v-model="qrData.vcard.vcity" label="شهر" outlined dense></v-text-field></v-col>
                  <v-col cols="12" md="6"><v-text-field v-model="qrData.vcard.vstate" label="استان" outlined dense></v-text-field></v-col>
                  <v-col cols="12" md="6"><v-text-field v-model="qrData.vcard.vcountry" label="کشور" outlined dense></v-text-field></v-col>
                </v-row>

              </v-expansion-panel-content>
            </v-expansion-panel>

                <v-expansion-panel
                  v-for="(item, i) in panels"
                  :key="i"
                  class="mb-4"
                >
                  <v-expansion-panel-header class="text-right">
                    <div class="d-flex justify-space-between align-center">
                      <div>
                        <v-icon class="me-2">mdi-{{ item.icon }}</v-icon>
                        {{ item.title }}
                      </div>
                      <help-info
                        :label="item.title"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="ms-2"
                        :element-name="`${serviceName}-${componentName}-${item.name}-${item.title}`"
                      />
                    </div>
                  </v-expansion-panel-header>

                  <v-expansion-panel-content class="py-5">
                      <component
                        :is="item.name"
                        v-model="options"
                        :colors="colors"
                        :readonly="false"
                        :design-object="
                            item.name === 'QrCodeDotsAdv' ? designObject_patttern :
                            item.name === 'QrCodeEyeAdv' ? designObject_dots :
                            item.name === 'QrCodeSquareAdv' ? designObject_square :
                            item.name === 'QrCodeFrameAdv' ? designObject_frames :
                            item.name === 'QrCodeLogoAdv' ? designObject_logos : []
                        "
                      />
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-card>
      </div>
      <ProgressModal2 ref="myProgress" />

    </template>
  </help-info-wrapper>
</template>

<script>
import { ir } from "../../../check_domain_ir.js";
import ProgressModal2 from "./ProgressModal2.vue";
import axios from "axios";
import HelpInfo from "../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QRCodeStyling from "qr-code-styling";
import { debounce } from "@/main";
import QrCodeData from "@/view/pages/qrland/qrCodeStyle/components/qrCodeData";
import ImportQrPage from "../bulkQrs/ImportQrPage.vue";
import SuggestText from "@/view/components/SuggestBox/suggestInput.vue";
import "vue-persian-datetime-picker";
import Swal from "sweetalert2";
import Vuetify from "vuetify/lib";
import { mapir, mapMarker, mapNavigationControl, mapGeolocateControl } from 'mapir-vue';
import 'mapir-vue/dist/mapir-vue.css'; 
import QrCodeDotsAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeDotsAdv";
import QrCodeEyeAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeEyeAdv";
import QrCodeOptions from "@/view/pages/qrland/qrCodeStyle/components/qrCodeOptions";
import QrCodeSquareAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeSquareAdv";
import QrCodeFrameAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeFrameAdv";
import QrCodeLogoAdv from "@/view/pages/qrland/qrCodeStyle/components/qrCodeLogoAdv";
import QrMaker from "@/view/pages/qrland/components/qrMaker.vue";


let qrCode = null;

export default {
  name: "generateMultipleQrCodeUser",
  components: {
    HelpInfo,
    HelpInfoWrapper,
    QrMaker,
    QrCodeData,
    QrCodeDotsAdv,
    QrCodeEyeAdv,
    QrCodeOptions,
    QrCodeSquareAdv,
    QrCodeFrameAdv,
    QrCodeLogoAdv,
    ImportQrPage,
    SuggestText,
     mapir,
    mapMarker,
    mapNavigationControl,
    mapGeolocateControl,
    ProgressModal2
  },

  data: () => ({
    showPassword: false,
    loadingbulidinglist: true,
    progressDialog: true,
    progressTitle: "اطلاع‌رسانی",
    progressMessage: "تست",
    showProgress: true,
    loading: true,
    random2:1,
    totalChunks:1000,
    currentChunk:1,
    qrDesign: null,
     mapLoading: false,
      searchQuery: null,
      searchTitle: null,
      suggests: [],
      designObject_dots: [],
      designObject_patttern: [],
      designObject_square: [],
      designObject_frames: [], 
      designObject_logos: [],

      datamap: {
        coordinates: [51.420470, 35.729054], // [lng, lat]
        address: ""
      },
    center: [51.420296, 35.732379],
    apiKey: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg',
    zoomMap: 15,
    isDownloading: false, 
    isFormChanged: false, 
    typeDownload:'svg',
    codeQr:'',
    rules: {
      url: v => !v || /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/.test(v) || 'آدرس اینترنتی معتبر نیست',
      email: v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'ایمیل معتبر نیست',
      postalCode: v => {
        if (!v) return true;
        if (v.length !== 10) return 'کد پستی باید دقیقاً ۱۰ رقم باشد';
        if (v.startsWith('00') || v.startsWith('2')) return 'کد پستی نامعتبر است (نباید با 00 یا 2 شروع شود)';
        if (/^(.)\1{9}$/.test(v)) return 'ارقام نمی‌توانند کاملاً تکراری باشند';
        return true;
      },
      positiveNumber: v => !v || v > 0 || 'مقدار باید بیشتر از صفر باشد',
      bitcoinAddress: v => !v || /^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$|^bc1[ac-hj-np-z02-9]{11,71}$/.test(v) || 'آدرس بیت‌کوین معتبر نیست',
      count: v=>!!v && v<=1000 || 'خداکثر تعداد مجاز برای ساخت کیوار 1000 تا میباشد.'
    },
    mapSearchQuery: "",
    mapInstance: null,
    mapMarker: null,
    mapScriptsLoaded: false,
    eventReminderOptions: [
      { text: '--', value: '' },
      { text: 'زمان شروع رویداد', value: 'PT0M' },
      { text: '5 دقیقه قبل', value: '-PT5M' },
      { text: '10 دقیقه قبل', value: '-PT10M' },
      { text: '15 دقیقه قبل', value: '-PT15M' },
      { text: '30 دقیقه قبل', value: '-PT30M' },
      { text: '1 ساعت قبل', value: '-PT1H' },
      { text: '2 ساعت قبل', value: '-PT2H' },
      { text: '3 ساعت قبل', value: '-PT3H' },
      { text: '4 ساعت قبل', value: '-PT4H' },
      { text: '5 ساعت قبل', value: '-PT5H' },
      { text: '6 ساعت قبل', value: '-PT6H' },
      { text: '12 ساعت قبل', value: '-PT12H' },
      { text: '24 ساعت قبل', value: '-P1D' },
      { text: '48 ساعت قبل', value: '-P2D' },
      { text: '1 هفته قبل', value: '-P1W' },
    ],
    paypalCurrencies: [
      { text: 'دلار آمریکا', value: 'USD' },
      { text: 'یورو', value: 'EUR' },
      { text: 'پوند بریتانیا', value: 'GBP' },
      { text: 'دلار استرالیا', value: 'AUD' },
      { text: 'دلار کانادا', value: 'CAD' },
      { text: 'ین ژاپن', value: 'JPY' },
      { text: 'فرانک سوئیس', value: 'CHF' },
      { text: 'کرونای چک', value: 'CZK' },
      { text: 'کرون دانمارک', value: 'DKK' },
      { text: 'دلار هنگ کنگ', value: 'HKD' },
      { text: 'فورینت مجارستان', value: 'HUF' },
      { text: 'شِکِل جدید اسرائیل', value: 'ILS' },
      { text: 'پزو مکزیک', value: 'MXN' },
      { text: 'دلار جدید تایوان', value: 'TWD' },
      { text: 'دلار نیوزیلند', value: 'NZD' },
      { text: 'کرون نروژ', value: 'NOK' },
      { text: 'پزو فیلیپین', value: 'PHP' },
      { text: 'زلوتی لهستان', value: 'PLN' },
      { text: 'روبل روسیه', value: 'RUB' },
      { text: 'دلار سنگاپور', value: 'SGD' },
      { text: 'کرون سوئد', value: 'SEK' },
      { text: 'بات تایلند', value: 'THB' }
    ],  
    selectedQrType: 'url',
    qrTypesList: [
      { title: 'لینک', value: 'url', icon: 'mdi-link' },
      { title: 'متن', value: 'text', icon: 'mdi-text-box-outline' },
      { title: 'ایمیل', value: 'email', icon: 'mdi-email-outline' },
      { title: 'تلفن', value: 'tel', icon: 'mdi-phone-outline' },
      { title: 'پیامک', value: 'sms', icon: 'mdi-message-text-outline' },
      { title: 'واتس‌اپ', value: 'whatsapp', icon: 'mdi-whatsapp' },
      { title: 'زوم', value: 'zoom', icon: 'mdi-video-outline' },
      { title: 'وای‌فای', value: 'wifi', icon: 'mdi-wifi' },
      { title: 'مکان', value: 'location', icon: 'mdi-map-marker-outline' },
      { title: 'وی‌کارت', value: 'vcard', icon: 'mdi-card-account-details-outline' },
      { title: 'پی‌پال', value: 'paypal', icon: 'mdi-cash' }, 
      { title: 'بیت‌کوین', value: 'bitcoin', icon: 'mdi-bitcoin' },
      { title: 'رویداد', value: 'event', icon: 'mdi-calendar-blank-outline' },
    ],
    qrData: {
      param: '', 
      email: { mailto: '', subject: '', body: '' },
      tel: { countrycodetel: '', tel: '' },
      sms: { countrycodesms: '', sms: '', bodysms: '' },
      whatsapp: { wapp_countrycode: '', wapp_number: '', wapp_message: '' },
      zoom: { zoom_id: '', zoom_pwd: '' },
      wifi: { ssid: '', wifipass: '', networktype: 'WPA2', wifihidden: false },
      location: { lat: '', lng: '' },
      bitcoin: { btc_account: '', btc_amount: '', btc_label: '', btc_message: '' },
      paypal: { pp_type: '_xclick', pp_email: '', pp_name: '', pp_id: '', pp_price: '', pp_currency: 'USD', pp_shipping: '', pp_tax: '' },
      event: { eventtitle: '', eventlocation: '', eventstarttime: '', eventendtime: '', eventreminder: '', eventlink: '', eventnote: '' },
      vcard: { vversion: '3.0', vnametitle: '', vname: '', vlast: '', countrycodevmobile: '', vmobile: '', vemail: '', vurl: '', vcompany: '', vtitle: '', countrycodevoffice: '', vofficephone: '', vaddress: '', vcity: '', vstate: '', vcountry: '', vcap: '', countrycodevfax: '', vfax: '' }
    },
    tabs:1,
    helpData: [],
    componentName: "generate-Multiple-QrCode-user",
    serviceName: "Qrland",
    loading: false,
    qrSvgDataUrl: [],
    count: 0,
    tabs1: 1,
    toggle_exclusive: 4,
    selectFromGroup: false,
    options: {
      outer_frame: "bottom",
      framelabel: "مرا اسکن کنید",
      label_font: "Parastoo.ttf",
      "label-text-size": 100,
      framecolor: "#1754ec",
      custom_frame_color: "on",

      optionlogo: "02-email-b.png",
      no_logo_bg: "on",
      logo_size: 100,
      width: 300,
      height: 300,
      data: "https://qr2.in",
      margin: 5,
      qrOptions: {
        typeNumber: 0,
        mode: "Byte",
        errorCorrectionLevel: "Q",
      },
      imageOptions: {
        hideBackgroundDots: true,
        imageSize: 0.4,
        margin: 0,
      },
      dotsOptions: {
        type: "extra-rounded",
        color: "#6a1a4c",
        gradient: {
          type: "linear",
          rotation: 0,
          colorStops: [
            {offset: 0, color: "#933490"},
            {offset: 1, color: "#933490"}
          ]
        }
      },
      backgroundOptions: {
        color: "#FFFFFFFF",
        gradient: null,
      },
      image: null,
      dotsOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#6a1a4c",
          color2: "#6a1a4c",
          rotation: "0",
        },
      },
      cornersSquareOptions: {
        type: "extra-rounded",
        gradient: null,
        color: "#690a70",
      },
      cornersSquareOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#000000",
          color2: "#000000",
          rotation: "0",
        },
      },
      cornersDotOptions: {
        type: "",
        color: "#b00cab",
        gradient: null,
      },
      cornersDotOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#000000",
          color2: "#000000",
          rotation: "0",
        },
      },
      backgroundOptionsHelper: {
        colorType: { single: true, gradient: false },
        gradient: {
          linear: true,
          radial: false,
          color1: "#ffffff",
          color2: "#ffffff",
          rotation: "0",
        },
      },
      different_borders_color: false,
      different_eyes_color: false,   
      marker_out_color: "#000000",
      marker_in_color: "#000000",
      marker_top_right_outline: "#000000",
      marker_bottom_left_outline: "#000000",
      marker_top_right_center: "#000000",
      marker_bottom_left_center: "#000000",
    },
    panels: [
      { name: "QrCodeData", title: "رنگ و سایز کیوآر", icon: "qrcode-edit" },
      { name: "QrCodeDotsAdv", title: "طرح و رنگ نقطه ها", icon: "dots-triangle" },
      { name: "QrCodeEyeAdv", title: "طرح و رنگ چشم", icon: "bullseye" },
      { name: "QrCodeSquareAdv", title: "طرح و رنگ حاشیه", icon: "rounded-corner" },
      { name: "QrCodeFrameAdv", title: "طراحی قاب", icon: "border-all" }, 
      { name: "QrCodeLogoAdv", title: "تنظیمات لوگو", icon: "image" }, 
      { name: "QrCodeOptions", title: "تنظیمات کیوآر", icon: "cogs" },
    ],
    colors: [
      ["#649173", "#DBD5A4"],
      ["#B993D6", "#8CA6DB"],
      ["#870000", "#190A05"],
      ["#00d2ff", "#3a7bd5"],
      ["#DAD299", "#B0DAB9"],
      ["#E6DADA", "#274046"],
      ["#50C9C3", "#96DEDA"],
      ["#4b6cb7", "#182848"],
      ["#EC6F66", "#F3A183"],
      ["#5f2c82", "#49a09d"],
    ],
    stylesList: [
      ["", "dots", "square"],
      ["", "dot", "rounded", "classy", "classy-rounded", "square", "extra-rounded"],
      ["", "dot", "square", "extra-rounded"],
    ],
  }),

  
     mounted() {
    qrCode = new QRCodeStyling(this.computedValue);
    this.ranColor().then(() => {
      this.updateStyle();
      this.$emit("save", this.options);
    });

    this.qrDesign =
      typeof this.options === "string"
        ? JSON.parse(this.options)
        : this.options;
    this.activePanels = [0];
    this.fetchDesigns();
  },


  watch: {
     searchQuery(val) {
      if (!val || val.length < 3) return;
      this.fetchSearchResults(val);
    },
      qrData: {
    deep: true,
    handler() { this.isFormChanged = true; }
  },
  options: {
    deep: true,
    handler() { this.isFormChanged = true; }
  },
  count() { 
    this.isFormChanged = true; 
  },
  selectedQrType() { 
    this.isFormChanged = true; 
  },
  },

  methods: {
    fetchDesigns() {
          this.$api.get("/v2/qr-gen/markers")
            .then(({ data }) => {
              const apiData = data.data;
              
              this.designObject_patttern = Object.keys(apiData.pattern || {}).map((key) => ({ value: key, img: apiData.pattern[key] }));
              this.designObject_dots = Object.keys(apiData.markerIn || {}).map((key) => ({ value: key, img: apiData.markerIn[key] }));
              this.designObject_square = Object.keys(apiData.markerOut || {}).map((key) => ({ value: key, img: apiData.markerOut[key] }));
              
              this.designObject_frames = Object.keys(apiData.frames || {}).map((key) => ({ 
                value: key, 
                data: apiData.frames[key] 
              }));
              
              this.designObject_logos = Object.keys(apiData.logos || {}).map((key) => ({ 
                value: key, 
                img: apiData.logos[key].preview 
              }));
            })
            .catch(() => {});
},
getlatLng(e) {
  if (e && e.actualEvent && e.actualEvent.lngLat) {
    this.mapLoading = true;
    const coords = e.actualEvent.lngLat;
    
    this.qrData.location.lng = coords.lng;
    this.qrData.location.lat = coords.lat;
      this.datamap.coordinates = [coords.lng, coords.lat];
      this.center = [coords.lng, coords.lat];

    axios({
      method: 'GET',
      baseURL: 'https://map.ir/reverse',
      params: { lat: coords.lat, lon: coords.lng }, 
      timeout: 15000,
      headers: {
        'x-api-key': this.apiKey,
        'Accept': 'application/json',
      }
    }).then((response) => {
      this.$set(this.qrData, 'address', response.data.address); 
      this.datamap.address = response.data.address_compact || response.data.address;


    }).catch((error) => {
      console.error("خطا در دریافت آدرس از مپ‌ایر:", error);
    }).finally(() => {
      this.mapLoading = false;
    });
  }
},
    fetchSearchResults(query) {
      this.mapLoading = true;
      axios.post('https://map.ir/search/v2/autocomplete', {
        "text": query || 'منطقه',
        "$select": "poi,roads,neighborhood,county",
      }, {
        timeout: 15000,
        headers: {
          'x-api-key': this.apiKey,
           'Content-Type': 'application/json',
        }
      }).then(response => {
        this.suggests = response.data.value || [];
      }).catch(error => {
        console.error("خطا در جستجو:", error);
      }).finally(() => {
        this.mapLoading = false;
      });
    },

    getBySearch(item) {
      if (item && item.geom && item.geom.coordinates) {
        const coords = item.geom.coordinates; // [lng, lat]
        this.center = coords;
        this.datamap.coordinates = coords;
        this.datamap.address = item.title || item.address;
        this.qrData.location.lng = coords.lng;
        this.qrData.location.lat = coords.lat;

        this.zoomMap = 16; 
      }
    },
    handlePhoneValidation({ number, valid, country }, group, countryField, numberField) {
      if (country && country.dialCode) {
        this.qrData[group][countryField] = country.dialCode;
      } else {
        this.qrData[group][countryField] = "";
      }
    },
createAdvance() {
  if(Number(this.count)===0)
  return;
    this.loading = true;
  this.qrSvgDataUrl = [];
  let currentTypeData = {};
  
  if (this.selectedQrType === 'url' || this.selectedQrType === 'text') {
    currentTypeData = { param: this.qrData.param };
  } else {
    currentTypeData = { ...this.qrData[this.selectedQrType] };
  }

  const opt = this.options;
  let backgroundColor = this.isGradient(opt.backgroundOptions);
  let frontColor = this.isGradient(opt.dotsOptions);
  let cornerSquare = this.isGradient(opt.cornersSquareOptions);
  let cornerDots = this.isGradient(opt.cornersDotOptions);

  let payload = {
    selectFromGroup: this.selectFromGroup,
    type: this.selectedQrType,
    number: Number(this.count) || 0,
   
    backcolor: backgroundColor.color,
    frontcolor: frontColor.color,
    pattern: opt.dotsOptions.type || "default",
    gradient: frontColor.isGradient || false,
    gradient_color: frontColor.color1 || null,
    radial: opt.dotsOptions.gradient?.type === 'radial' || false,
    random2: this.random2 || false,
    
    // تنظیمات اشکال چشم‌ها و حاشیه‌ها
    markers_color: opt.cornersSquareOptions.color ? true : false,
    marker_out: opt.cornersSquareOptions.type || "default",
    marker_in: opt.cornersDotOptions.type || "default",
    
    // اگر کاربر تیک "رنگ متفاوت حاشیه‌ها" را زده باشد رنگ‌های مجزا را می‌فرستد، در غیر این‌صورت رنگ اصلیِ cornerSquare را جایگذاری می‌کند
    marker_out_color: opt.different_borders_color ? opt.marker_out_color : (cornerSquare.color || null),
    marker_top_right_outline: opt.different_borders_color ? opt.marker_top_right_outline : (cornerSquare.color || null),
    marker_bottom_left_outline: opt.different_borders_color ? opt.marker_bottom_left_outline : (cornerSquare.color || null),

    // اگر کاربر تیک "رنگ متفاوت مرکز چشم‌ها" را زده باشد رنگ‌های مجزا را می‌فرستد، در غیر این‌صورت رنگ اصلیِ cornerDots را جایگذاری می‌کند
    marker_in_color: opt.different_eyes_color ? opt.marker_in_color : (cornerDots.color || null),
    marker_top_right_center: opt.different_eyes_color ? opt.marker_top_right_center : (cornerDots.color || null),
    marker_bottom_left_center: opt.different_eyes_color ? opt.marker_bottom_left_center : (cornerDots.color || null),

    // متغیر کنترل‌کننده‌ای که به سرور می‌گوید آیا رنگ‌های متفاوتی برای چشم‌ها و حاشیه‌ها در کار است یا خیر
    different_markers_color: opt.different_borders_color || opt.different_eyes_color || false,
    
    level: opt.imageOptions?.errorCorrectionLevel || this.qrData.level || "M",
    outer_frame: opt.outer_frame,
    framelabel: opt.framelabel,
    label_font: opt.label_font,
    "label-text-size": opt["label-text-size"],
    framecolor: opt.custom_frame_color === 'on' ? opt.framecolor : '',
    custom_frame_color: opt.custom_frame_color,    
    optionlogo: opt.optionlogo,
    no_logo_bg: opt.no_logo_bg,
    logo_size: opt.logo_size,

    ...currentTypeData 
  };

  // ۴. خالی کردن مقادیر رشته‌های خالی برای جلوگیری از خطای سرور
  // for (const key in payload) {
  //   if (payload[key] === "") payload[key] = null;
  // }

  // ۵. ارسال درخواست به API
  this.$api
    .post("/v2/qr-gen/group-new", payload)
    .then(({ data }) => {
      let r = [];
      this.codeQr = data?.data?.id;
      data?.data?.svgs?.forEach((item) => r.push(item));
      this.qrSvgDataUrl = r;
      
      // پیام موفقیت
      this.$toast.success('کیوآرکدها با موفقیت ایجاد شدند.');
      
      this.isFormChanged = false; 
    })
    .catch(err => {
        if(err.response && err.response.status === 422) {
            const errorMsg = err.response.data.errors 
               ? Object.values(err.response.data.errors).join(' \n')
               : 'اطلاعات وارد شده نامعتبر است.';
            this.$toast.error(errorMsg);
        } else {
            this.$toast.error('خطایی در ارتباط با سرور رخ داد.');
        }
    })
    .finally(() => (this.loading = false));
},
    async downloadQr() {
  if (!this.codeQr || !this.typeDownload) {
    this.$toast.warning('خطا در فرایتد رخ داد. لطفاً ابتدا کیوآرکدها را تولید کنید.');
    return;
  }


  this.isDownloading = true;

  try {
    const downloadUrl = `/v2/qr-gen/exportGroup/${this.codeQr}?image_type=${this.typeDownload}`;
    
    let isDone = false;
       this.$refs.myProgress.open({
        title: "در حال دانلود QR...",
        message: 'کیوآرکدهای شما در حال آماده‌سازی هستند',
        showProgress: true,
        duration: 10000 
      });

    while (!isDone) {
      const { data } = await this.$api.get(downloadUrl);
        if (data.data?.status ===  'started') {
          this.totalChunks = data.data?.chunks; 
        }
        if(data.data?.status === 'processing'){
          this.currentChunk = (data.data?.progress||0)+1;
        }

        const percent = Math.round((this.currentChunk / this.totalChunks) * 100);
        
        this.$refs.myProgress.progress = percent;
        this.$refs.myProgress.message = `بخش دوم: در حال دریافت بخش ${this.currentChunk} از ${this.totalChunks}`;
    
      if (data.data?.status === 'done') {
        isDone = true;
        const link = document.createElement('a');
        link.href = ir(data.data.file); 
        link.setAttribute('download', `qrcodes_${this.codeQr}.zip`); 
        link.setAttribute('target', '_blank'); 
         document.body.appendChild(link);
        link.click();
        link.remove();        
        this.$toast.success('فایل شما با موفقیت دانلود شد.');
      } else {
        await new Promise(resolve => setTimeout(resolve, 10000));
      }
    }
  } catch (error) {
    console.error("Download Error:", error);
    this.$toast.error('خطایی در فرآیند دانلود فایل رخ داد.');
  } finally {
    this.isDownloading = false;
    this.$refs.myProgress.complete();

  }
},
    updateStyle(timer = false, options = this.options) {
      if (this.tabs === 1) {
        debounce(() => {
          this.createAdvance();
        }, 1500);
        return;
      }

      this.loading = true;

      this.$nextTick(() => {
        this.qrSvgDataUrl = [];
        const _this = this;

        async function* generator() {
          let i = 0;

          while (i < _this.count) {
            const field = [
              "dotsOptions",
              "cornersDotOptions",
              "cornersSquareOptions",
            ];
            _this.stylesList.forEach((item, index) => {
              options[field[index]].type =
                item[Math.floor(Math.random() * item.length)];
            });

            qrCode.update(options);

            let blob = await qrCode.getRawData("png");
            const reader = new FileReader();

            const readAsDataURL = new Promise((resolve) => {
              reader.addEventListener("loadend", () => {
                resolve(reader.result);
              });
            });

            reader.readAsDataURL(blob);
            i++;

            yield await readAsDataURL;
          }
        }

        let res = [];
        debounce(
          () => {
            (async () => {
              for await (const num of generator()) {
                res.push(num);
              }
              this.qrSvgDataUrl = res;
              this.loading = false;
            })();
          },
          !!timer ? 1500 : 0,
        );
      });
    },
    ranColor() {
      return new Promise((resolve, reject) => {
        let rand = this.colors[Math.floor(Math.random() * 10)];
        try {
          this.options.dotsOptions.gradient.colorStops = [
            { offset: 0, color: rand[0] },
            { offset: 1, color: rand[1] },
          ];
          resolve("resolve");
        } catch (e) {
          console.log("failed to generate random color: ", e);
          reject();
        }
      });
    },
    downloadSvgImg(base64, index) {
      const filename = `image-${this.options.data
        .trim()
        .replace(/\.*\s*/g, "_")}-${index}.png`;

      let canvas = document.createElement("canvas");
      let context = canvas.getContext("2d");
      let pngData = "";

      canvas.width = 300;
      canvas.height = 300;
      let image = new Image();
      image.onload = function () {
        context.clearRect(0, 0, 300, 300);
        context.drawImage(image, 0, 0, 300, 300);
        pngData = canvas.toDataURL("image/png");
 
        const byteCharacters = atob(pngData.split(",")[1]); 
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "image/png" }); 

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename; 

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      }; 
      image.src = base64;
    },
    downloadImg(base64, index) {
      const filename = `image-${this.options.data
        .trim()
        .replace(/\.*\s*/g, "_")}-${index}.png`;

      const byteCharacters = atob(base64.split(",")[1]); 
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "image/png" }); 

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename; 

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    },
    isGradient(opt) {
      let res = {
        color: "",
        color1: "",
        isGradient: false,
      };

      if (opt.hasOwnProperty("gradient") && !!opt.gradient) {
        res = {
          isGradient: true,
          color: opt.gradient.colorStops[0].color,
          color1: opt.gradient.colorStops[1].color,
        };
      } else
        res = {
          isGradient: false,
          color: opt.color,
          color1: null,
        };

      return res;
    },
  },
};
</script>

<style scoped>
.v-expansion-panel {
  border-radius: 15px !important;
  box-shadow: 8px 5px 10px #f49d1a;
}

.v-expansion-panel
  >>> .v-expansion-panel-header.v-expansion-panel-header--active {
  background-color: #001554 !important;
  border-radius: 15px !important;
  color: whitesmoke !important;
}

.v-expansion-panel
  >>> .v-expansion-panel-header.v-expansion-panel-header--active
  .v-icon {
  color: whitesmoke !important;
}

.v-tabs >>> .v-tabs-slider-wrapper {
  display: block !important;
}

.advance-image-data,
.advance-image-data >>> svg {
  max-width: 100%;
  max-height: 120px;
}
.phone-input {
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.38); 
}
.stylephone {
  display: flex;
  flex-direction: column;
  width: 100% !important;
}
.phone-input:focus-within {
  border-color: var(--v-primary-base, #1976D2); 
  border-width: 2px;
}
.qr-wrapper :deep(svg) { 
    height: auto !important; 
    max-height: 167px !important; 
    width: 100%; 
}
.qr-type-card {
  border: 1px solid #e0e0e0;
  cursor: pointer;
}
.qr-type-card:hover {
  transform: translateY(-3px);
  border-color: var(--v-primary-base);
  box-shadow: 0 4px 15px rgba(0,0,0,0.08) !important;
}
.qr-type-card {
  border: 1px solid #f0f0f0;
  cursor: pointer;
  transition: all 0.3s ease;
}
.qr-type-card:hover {
  border-color: #0a194e;
  background-color: #f8f9fa;
}
.v-card--link:focus:before {
  opacity: 0;
}
</style>
